
export default function Services() {
  const services = [
    {
      icon: 'ri-building-line',
      title: 'Construction Project Management',
      description: 'End-to-end project oversight ensuring timely delivery, budget control, and quality assurance for complex facility construction.',
      features: ['Project Planning & Scheduling', 'Quality Control Systems', 'Budget Management', 'Risk Assessment']
    },
    {
      icon: 'ri-temp-cold-line',
      title: 'HVAC Installation & Systems',
      description: 'Advanced heating, ventilation, and air conditioning solutions designed for optimal efficiency and environmental control.',
      features: ['Custom HVAC Design', 'Energy Efficient Systems', 'Maintenance Programs', 'Smart Controls Integration']
    },
    {
      icon: 'ri-tools-line',
      title: 'Specialty Facility Projects',
      description: 'Tailored solutions for unique and niche facility requirements, from clean rooms to industrial processing plants.',
      features: ['Clean Room Construction', 'Industrial Facilities', 'Laboratory Environments', 'Custom Engineering']
    }
  ];

  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-slate-800 mb-6">
            Our Core Services
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Delivering precision-engineered solutions across construction management, HVAC systems, and specialty facility projects with unmatched technical expertise.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div key={index} className="bg-white rounded-xl p-8 shadow-lg hover:shadow-xl transition-shadow">
              <div className="w-16 h-16 bg-slate-800 rounded-lg flex items-center justify-center mb-6">
                <i className={`${service.icon} text-2xl text-orange-500`}></i>
              </div>
              <h3 className="text-2xl font-bold text-slate-800 mb-4">{service.title}</h3>
              <p className="text-gray-600 mb-6 leading-relaxed">{service.description}</p>
              <ul className="space-y-2">
                {service.features.map((feature, idx) => (
                  <li key={idx} className="flex items-center text-gray-700">
                    <i className="ri-check-line text-green-600 mr-3"></i>
                    {feature}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
